// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/connect/v2/resources/address.proto
/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Country } from "./country";
export const protobufPackage = "squareup.connect.v2.resources";
function createBaseAddress() {
    return {
        $type: "squareup.connect.v2.resources.Address",
        addressLine1: undefined,
        addressLine2: undefined,
        addressLine3: undefined,
        locality: undefined,
        sublocality: undefined,
        sublocality2: undefined,
        sublocality3: undefined,
        administrativeDistrictLevel1: undefined,
        administrativeDistrictLevel2: undefined,
        administrativeDistrictLevel3: undefined,
        postalCode: undefined,
        country: undefined,
        firstName: undefined,
        lastName: undefined,
        organization: undefined,
    };
}
export const Address = {
    $type: "squareup.connect.v2.resources.Address",
    encode(message, writer = _m0.Writer.create()) {
        if (message.addressLine1 !== undefined) {
            writer.uint32(10).string(message.addressLine1);
        }
        if (message.addressLine2 !== undefined) {
            writer.uint32(18).string(message.addressLine2);
        }
        if (message.addressLine3 !== undefined) {
            writer.uint32(26).string(message.addressLine3);
        }
        if (message.locality !== undefined) {
            writer.uint32(50).string(message.locality);
        }
        if (message.sublocality !== undefined) {
            writer.uint32(58).string(message.sublocality);
        }
        if (message.sublocality2 !== undefined) {
            writer.uint32(66).string(message.sublocality2);
        }
        if (message.sublocality3 !== undefined) {
            writer.uint32(74).string(message.sublocality3);
        }
        if (message.administrativeDistrictLevel1 !== undefined) {
            writer.uint32(106).string(message.administrativeDistrictLevel1);
        }
        if (message.administrativeDistrictLevel2 !== undefined) {
            writer.uint32(114).string(message.administrativeDistrictLevel2);
        }
        if (message.administrativeDistrictLevel3 !== undefined) {
            writer.uint32(122).string(message.administrativeDistrictLevel3);
        }
        if (message.postalCode !== undefined) {
            writer.uint32(130).string(message.postalCode);
        }
        if (message.country !== undefined) {
            writer.uint32(136).int32(message.country);
        }
        if (message.firstName !== undefined) {
            writer.uint32(146).string(message.firstName);
        }
        if (message.lastName !== undefined) {
            writer.uint32(154).string(message.lastName);
        }
        if (message.organization !== undefined) {
            writer.uint32(162).string(message.organization);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAddress();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.addressLine1 = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.addressLine2 = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.addressLine3 = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.locality = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.sublocality = reader.string();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.sublocality2 = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.sublocality3 = reader.string();
                    continue;
                case 13:
                    if (tag !== 106) {
                        break;
                    }
                    message.administrativeDistrictLevel1 = reader.string();
                    continue;
                case 14:
                    if (tag !== 114) {
                        break;
                    }
                    message.administrativeDistrictLevel2 = reader.string();
                    continue;
                case 15:
                    if (tag !== 122) {
                        break;
                    }
                    message.administrativeDistrictLevel3 = reader.string();
                    continue;
                case 16:
                    if (tag !== 130) {
                        break;
                    }
                    message.postalCode = reader.string();
                    continue;
                case 17:
                    if (tag !== 136) {
                        break;
                    }
                    message.country = reader.int32();
                    continue;
                case 18:
                    if (tag !== 146) {
                        break;
                    }
                    message.firstName = reader.string();
                    continue;
                case 19:
                    if (tag !== 154) {
                        break;
                    }
                    message.lastName = reader.string();
                    continue;
                case 20:
                    if (tag !== 162) {
                        break;
                    }
                    message.organization = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Address.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddress();
        message.addressLine1 = object.addressLine1 ?? undefined;
        message.addressLine2 = object.addressLine2 ?? undefined;
        message.addressLine3 = object.addressLine3 ?? undefined;
        message.locality = object.locality ?? undefined;
        message.sublocality = object.sublocality ?? undefined;
        message.sublocality2 = object.sublocality2 ?? undefined;
        message.sublocality3 = object.sublocality3 ?? undefined;
        message.administrativeDistrictLevel1 = object.administrativeDistrictLevel1 ?? undefined;
        message.administrativeDistrictLevel2 = object.administrativeDistrictLevel2 ?? undefined;
        message.administrativeDistrictLevel3 = object.administrativeDistrictLevel3 ?? undefined;
        message.postalCode = object.postalCode ?? undefined;
        message.country = object.country ?? undefined;
        message.firstName = object.firstName ?? undefined;
        message.lastName = object.lastName ?? undefined;
        message.organization = object.organization ?? undefined;
        return message;
    },
};
